import React from "react";
import { Heading, Subheading } from "../../design/heading";
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "../../design/table";
import { useParentingPlan } from "../../contexts/ParentingPlanContext";
import CreateParentingPlanButton from "../../components/CreateParentingPlanButton/CreateParentingPlanButton";
import EmptyStateView from "../../components/EmptyStateView";
import ParentingPlanListItem from "./ParentingPlanListItem";
import ErrorView from "../../components/ErrorView";
import LoadingView from "../../components/LoadingView";
import { useMatter } from "../../contexts/MatterContext";
import NoMatterView from "../../components/NoMatterView";

const ParentingPlanListPage: React.FC = () => {
  const { currentMatterId } = useMatter();
  const { parentingPlans, loading, error } = useParentingPlan();

  if (loading.list) {
    return <LoadingView title="Loading parentingPlans..." />;
  }

  if (error.list) {
    return <ErrorView error={error.list} />;
  }

  return (
    <div>
      <div className="flex items-end justify-between gap-4 mb-6">
        <Heading className="text-2xl font-bold">Parenting Plans</Heading>
        <div className="flex space-x-4">
          <CreateParentingPlanButton />
        </div>
      </div>
      {parentingPlans.length === 0 && (
        <EmptyStateView
          title="No ParentingPlans"
          message="No parentingPlans found. Create some to get started."
        />
      )}
      {parentingPlans.length > 0 && (
        <Table className="[--gutter:theme(spacing.6)] lg:[--gutter:theme(spacing.10)]">
          <TableHead>
            <TableRow>
              <TableHeader className="text-left">Name</TableHeader>
              <TableHeader>Status</TableHeader>
              <TableHeader>Effective Date</TableHeader>
              <TableHeader>Expiration Date</TableHeader>
              <TableHeader className="text-right">Last Updated</TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {parentingPlans.map((parentingPlan) => (
              <ParentingPlanListItem
                key={parentingPlan._id}
                parentingPlan={parentingPlan}
              />
            ))}
          </TableBody>
        </Table>
      )}
    </div>
  );
};

export default ParentingPlanListPage;
